import { ɵɵdefineInjectable, Injectable, Directive, TemplateRef, Input, Component, Optional, ContentChildren, NgModule } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { CommonModule } from '@angular/common';

/**
 * The display mode of the validation errors. For a given control, either all the validation errors
 * are displayed, or only the first one.
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/forms';
import * as ɵngcc2 from '@angular/common';

function ValidationErrorsComponent_ng_container_0_div_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c0 = function (a0, a1) { return { $implicit: a0, error: a1 }; };
function ValidationErrorsComponent_ng_container_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, ValidationErrorsComponent_ng_container_0_div_1_ng_container_1_Template, 1, 0, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const errorDirective_r2 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMap(ctx_r1.errorClasses);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", errorDirective_r2.templateRef)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(4, _c0, ctx_r1.label, ctx_r1.actualControl.errors[errorDirective_r2.type]));
} }
function ValidationErrorsComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, ValidationErrorsComponent_ng_container_0_div_1_Template, 2, 7, "div", 1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.errorDirectivesToDisplay);
} }
var DisplayMode;
(function (DisplayMode) {
    DisplayMode[DisplayMode["ALL"] = 0] = "ALL";
    DisplayMode[DisplayMode["ONE"] = 1] = "ONE";
})(DisplayMode || (DisplayMode = {}));
/**
 * The configuration service used by the validation errors component to apply common rules for all
 * form controls.
 *
 * To change its default behavior, you can either inject this service in your root module or component and mutate it,
 * or define your own implementation and provide it.
 */
class ValdemortConfig {
    constructor() {
        /**
         * The display mode of the errors. The default value is ALL, meaning that all the errors existing on a control
         * (and which have an error template defined) are displayed.
         */
        this.displayMode = DisplayMode.ALL;
        /**
         * Specifies one or several CSS classes (separated by a white space) that are automatically added to the
         * validation errors element. This can be useful to reuse a standard CSS class of your CSS framework (like
         * .invalid-feedback in BootStrap), rather than styling the val-errors element itself.
         *
         * The default value is null (no class is added).
         */
        this.errorsClasses = null;
        /**
         * Specifies one or several CSS classes (separated by a white space) that are automatically added to the
         * each validation error message element. This can be useful to reuse a standard CSS class of your CSS framework
         * rather than styling the div element itself.
         *
         * The default value is null (no class is added).
         */
        this.errorClasses = null;
        /**
         * Specifies when error messages should be displayed. based on the state of the control itself (touched, dirty, etc.)
         * and on the state of the form directive containing it (if any). This function is only called if the control is invalid
         * in the first place: if it's valid, errors are never displayed.
         *
         * The default value of this function returns true if the control is touched, or if the form (if any) is submitted.
         */
        this.shouldDisplayErrors = (control, form) => control.touched || (!!form && form.submitted);
    }
}
ValdemortConfig.ɵfac = function ValdemortConfig_Factory(t) { return new (t || ValdemortConfig)(); };
ValdemortConfig.ɵprov = ɵɵdefineInjectable({ factory: function ValdemortConfig_Factory() { return new ValdemortConfig(); }, token: ValdemortConfig, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ValdemortConfig, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

/**
 * Service used by the default validation errors directive to store the default error template references. This
 * service is injected in the validation errors component which displays the appropriate templates and provides their context.
 */
class DefaultValidationErrors {
    constructor() {
        this.directives = [];
    }
}
DefaultValidationErrors.ɵfac = function DefaultValidationErrors_Factory(t) { return new (t || DefaultValidationErrors)(); };
DefaultValidationErrors.ɵprov = ɵɵdefineInjectable({ factory: function DefaultValidationErrors_Factory() { return new DefaultValidationErrors(); }, token: DefaultValidationErrors, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DefaultValidationErrors, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

/* tslint:disable:directive-selector */
/**
 * Directive allowing to define the template for an error of a given type (using the `valError` input), using an ng-template.
 * It's used inside the body of the validation errors component, or inside the body of the default validation errors directive.
 * See the documentation of these two for example usages.
 */
class ValidationErrorDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
}
ValidationErrorDirective.ɵfac = function ValidationErrorDirective_Factory(t) { return new (t || ValidationErrorDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.TemplateRef)); };
ValidationErrorDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: ValidationErrorDirective, selectors: [["ng-template", "valError", ""]], inputs: { type: ["valError", "type"] } });
ValidationErrorDirective.ctorParameters = () => [
    { type: TemplateRef }
];
ValidationErrorDirective.propDecorators = {
    type: [{ type: Input, args: ['valError',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ValidationErrorDirective, [{
        type: Directive,
        args: [{ selector: 'ng-template[valError]' }]
    }], function () { return [{ type: ɵngcc0.TemplateRef }]; }, { type: [{
            type: Input,
            args: ['valError']
        }] }); })();

/* tslint:disable:use-host-property-decorator */
/**
 * Component allowing to display validation error messages associated to a given form control, form group or form array.
 * The control is provided using the `control` input of the component. If it's used inside an enclosing form group or
 * form array, it can instead be provided using the `controlName` input of the component.
 *
 * Example usage where the control itself is being passed as input:
 * ```
 *   <val-errors [control]="form.get('birthDate')">
 *     <ng-template valError="required">The birth date is mandatory</ng-template>
 *     <ng-template valError="max" let-error="error">The max value for the birth date is {{ error.max | number }}</ng-template>
 *   </val-errors>
 * ```
 *
 * Example usage where the control name is being passed as input:
 * ```
 *   <val-errors controlName="birthDate">
 *     <ng-template valError="required">The birth date is mandatory</ng-template>
 *     <ng-template valError="max" let-error="error">The max value for the birth date is {{ error.max | number }}</ng-template>
 *   </val-errors>
 * ```
 *
 * This component, if the control is invalid, displays its validation errors using the provided templates.
 * The templates, as shown in the above example, have access to the validation error itself.
 *
 * The label of the control can also be provided as input, and then used in the templates:
 * ```
 *   <val-errors controlName="birthDate" label="the birth date">
 *     <ng-template valError="required" let-label>{{ label }} is mandatory</ng-template>
 *     <ng-template valError="max" let-error="error" let-label>The max value for {{ label }} is {{ error.max | number }}</ng-template>
 *   </val-errors>
 * ```
 *
 * The component‘s behavior is configured globally by the Config service (see its documentation for more details). It can
 * - display the first error, or all the errors
 * - add CSS classes to its host `<val-errors>` element
 * - add CSS classes to each error message element being displayed
 * - choose when to display the errors (dirty, touched, touched and submitted, etc.)
 *
 * Global, default templates can be defined (and used by this component) using the default validation errors directive
 * (see its documentation for details). So, if the default error messages are defined and sufficient for a given control, all you
 * need is
 *
 * ```
 * <val-errors controlName="birthDate"></val-errors>
 * ```
 *
 * or, if the default templates expect a label:
 *
 * ```
 * <val-errors controlName="birthDate" label="the birth date"></val-errors>
 * ```
 *
 * If, however, you want to override one or several error messages by custom ones, you can do so by simply defining them inside the
 * component:
 *
 * ```
 * <val-errors controlName="birthDate" label="the birth date">
 *   <ng-template valError="max">You're too young, sorry</ng-template>
 * </val-errors>
 * ```
 *
 * If an error is present on the control, but doesn't have any template or default template defined for its type, then it's not
 * displayed. If the control is valid, or if none of the errors of the component has a matching template or default template,
 * then this component itself is hidden.
 */
class ValidationErrorsComponent {
    /**
     * @param config the Config service instance, defining the behavior of this component
     * @param defaultValidationErrors the service holding the default error templates, optionally
     * defined by using the default validation errors directive
     * @param controlContainer one of the 4 form group or form array directives that can "wrap" the control.
     * It's injected so that we can know if it exists and, if it does, if its form directive has been submitted or not:
     * the config service shouldDisplayErrors function can choose (and does by default) to use that information.
     */
    constructor(config, defaultValidationErrors, controlContainer) {
        this.config = config;
        this.defaultValidationErrors = defaultValidationErrors;
        this.controlContainer = controlContainer;
    }
    get shouldDisplayErrors() {
        const ctrl = this.actualControl;
        if (!ctrl || !ctrl.invalid || !this.hasDisplayableError(ctrl)) {
            return false;
        }
        const form = this.controlContainer && this.controlContainer.formDirective;
        return this.config.shouldDisplayErrors(ctrl, form);
    }
    get errorsClasses() {
        return this.config.errorsClasses || '';
    }
    get errorClasses() {
        return this.config.errorClasses || '';
    }
    get errorDirectivesToDisplay() {
        const mergedDirectives = [];
        const alreadyMetTypes = new Set();
        const shouldContinue = () => (this.config.displayMode === DisplayMode.ALL || mergedDirectives.length === 0);
        const ctrl = this.actualControl;
        for (let i = 0; i < this.defaultValidationErrors.directives.length && shouldContinue(); i++) {
            const defaultDirective = this.defaultValidationErrors.directives[i];
            alreadyMetTypes.add(defaultDirective.type);
            if (ctrl.hasError(defaultDirective.type)) {
                const customDirectiveOfSameType = this.errorDirectives.find(dir => dir.type === defaultDirective.type);
                mergedDirectives.push(customDirectiveOfSameType || defaultDirective);
            }
        }
        const customDirectives = this.errorDirectives.toArray();
        for (let i = 0; i < customDirectives.length && shouldContinue(); i++) {
            const customDirective = customDirectives[i];
            if (ctrl.hasError(customDirective.type) && !alreadyMetTypes.has(customDirective.type)) {
                mergedDirectives.push(customDirective);
            }
        }
        return mergedDirectives;
    }
    get actualControl() {
        return this.control ||
            ((this.controlName || (this.controlName === 0)) &&
                this.controlContainer &&
                this.controlContainer.control &&
                this.controlContainer.control.controls[this.controlName]);
    }
    hasDisplayableError(ctrl) {
        return ctrl.errors && Object.keys(ctrl.errors).some(type => this.defaultValidationErrors.directives.some(dir => dir.type === type)
            || this.errorDirectives.some(dir => dir.type === type));
    }
}
ValidationErrorsComponent.ɵfac = function ValidationErrorsComponent_Factory(t) { return new (t || ValidationErrorsComponent)(ɵngcc0.ɵɵdirectiveInject(ValdemortConfig), ɵngcc0.ɵɵdirectiveInject(DefaultValidationErrors), ɵngcc0.ɵɵdirectiveInject(ɵngcc1.ControlContainer, 8)); };
ValidationErrorsComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: ValidationErrorsComponent, selectors: [["val-errors"]], contentQueries: function ValidationErrorsComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, ValidationErrorDirective, 0);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.errorDirectives = _t);
    } }, hostVars: 4, hostBindings: function ValidationErrorsComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.errorsClasses);
        ɵngcc0.ɵɵstyleProp("display", ctx.shouldDisplayErrors ? "" : "none");
    } }, inputs: { control: "control", controlName: "controlName", label: "label" }, decls: 1, vars: 1, consts: [[4, "ngIf"], [3, "class", 4, "ngFor", "ngForOf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function ValidationErrorsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ValidationErrorsComponent_ng_container_0_Template, 2, 1, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.shouldDisplayErrors);
    } }, directives: [ɵngcc2.NgIf, ɵngcc2.NgForOf, ɵngcc2.NgTemplateOutlet], encapsulation: 2 });
ValidationErrorsComponent.ctorParameters = () => [
    { type: ValdemortConfig },
    { type: DefaultValidationErrors },
    { type: ControlContainer, decorators: [{ type: Optional }] }
];
ValidationErrorsComponent.propDecorators = {
    control: [{ type: Input }],
    controlName: [{ type: Input }],
    label: [{ type: Input }],
    errorDirectives: [{ type: ContentChildren, args: [ValidationErrorDirective,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ValidationErrorsComponent, [{
        type: Component,
        args: [{
                selector: 'val-errors',
                template: "<ng-container *ngIf=\"shouldDisplayErrors\">\n  <div [class]=\"errorClasses\" *ngFor=\"let errorDirective of errorDirectivesToDisplay\">\n    <ng-container *ngTemplateOutlet=\"errorDirective!.templateRef; context: {\n      $implicit: label,\n      error: actualControl.errors![errorDirective.type]\n    }\"></ng-container>\n  </div>\n</ng-container>\n",
                host: {
                    '[class]': 'errorsClasses',
                    '[style.display]': `shouldDisplayErrors ? '' : 'none'`
                }
            }]
    }], function () { return [{ type: ValdemortConfig }, { type: DefaultValidationErrors }, { type: ɵngcc1.ControlContainer, decorators: [{
                type: Optional
            }] }]; }, { control: [{
            type: Input
        }], controlName: [{
            type: Input
        }], label: [{
            type: Input
        }], errorDirectives: [{
            type: ContentChildren,
            args: [ValidationErrorDirective]
        }] }); })();

/* tslint:disable:use-host-property-decorator */
/**
 * Directive allowing to register default templates for validation error messages. It's supposed to be used once,
 * typically in the root component. By using templates to do that, error messages can
 * - easily be i18ned
 * - easily use pipes
 * - easily use HTML
 * - easily be ordered
 *
 * Example usage:
 * ```
 *   <val-default-errors>
 *     <ng-template valError="required">This field is mandatory</ng-template>
 *     <ng-template valError="max" let-error="error">This field must be at most {{ error.max | number }}</ng-template>
 *   </val-default-errors>
 * ```
 *
 * Example usage where a label is used to make the messages less generic:
 * ```
 *   <val-default-errors>
 *     <ng-template valError="required" let-label>{{ label }} is mandatory</ng-template>
 *     <ng-template valError="max" let-error="error" let-label>{{ label }} must be at most {{ error.max | number }}</ng-template>
 *   </val-default-errors>
 * ```
 *
 * This directive stores the default template references in a service, that is then injected in the validation errors components
 * to be reused.
 */
class DefaultValidationErrorsDirective {
    constructor(defaultValidationErrors) {
        this.defaultValidationErrors = defaultValidationErrors;
    }
    ngAfterContentInit() {
        this.defaultValidationErrors.directives = this.errorDirectives.toArray();
    }
}
DefaultValidationErrorsDirective.ɵfac = function DefaultValidationErrorsDirective_Factory(t) { return new (t || DefaultValidationErrorsDirective)(ɵngcc0.ɵɵdirectiveInject(DefaultValidationErrors)); };
DefaultValidationErrorsDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: DefaultValidationErrorsDirective, selectors: [["val-default-errors"]], contentQueries: function DefaultValidationErrorsDirective_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, ValidationErrorDirective, 0);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.errorDirectives = _t);
    } }, hostAttrs: [2, "display", "none"] });
DefaultValidationErrorsDirective.ctorParameters = () => [
    { type: DefaultValidationErrors }
];
DefaultValidationErrorsDirective.propDecorators = {
    errorDirectives: [{ type: ContentChildren, args: [ValidationErrorDirective,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DefaultValidationErrorsDirective, [{
        type: Directive,
        args: [{
                selector: 'val-default-errors',
                host: {
                    style: 'display: none'
                }
            }]
    }], function () { return [{ type: DefaultValidationErrors }]; }, { errorDirectives: [{
            type: ContentChildren,
            args: [ValidationErrorDirective]
        }] }); })();

class ValdemortModule {
}
ValdemortModule.ɵfac = function ValdemortModule_Factory(t) { return new (t || ValdemortModule)(); };
ValdemortModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: ValdemortModule });
ValdemortModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(ValdemortModule, { declarations: function () { return [ValidationErrorsComponent, ValidationErrorDirective, DefaultValidationErrorsDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [ValidationErrorsComponent, ValidationErrorDirective, DefaultValidationErrorsDirective]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ValdemortModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule
                ],
                declarations: [
                    ValidationErrorsComponent,
                    ValidationErrorDirective,
                    DefaultValidationErrorsDirective
                ],
                exports: [
                    ValidationErrorsComponent,
                    ValidationErrorDirective,
                    DefaultValidationErrorsDirective
                ]
            }]
    }], null, null); })();

/* tslint:disable */

/**
 * Generated bundle index. Do not edit.
 */

export { DisplayMode, ValdemortConfig, ValdemortModule, ValidationErrorsComponent as ɵa, ValidationErrorDirective as ɵb, DefaultValidationErrors as ɵc, DefaultValidationErrorsDirective as ɵd };

//# sourceMappingURL=ngx-valdemort.js.map